import { GridColumnCommonOptionsType } from '../enums';

const GridStickyCell = {
  methods: {
    getStickyStyles(columnOptions, stickyPosition) {
      const isSticky = columnOptions?.[GridColumnCommonOptionsType.IsSticky];

      if (!isSticky) {
        return {};
      }

      return { left: `${stickyPosition}px`, position: 'sticky' };
    },
  },
};

export default GridStickyCell;
